import {ObjectProperties} from '../../query/data/specifics/communicationProperties';
import {QueryableEnum, QueryableProperty} from '../../query/data/queryableProperty';
import {AppointmentReminderTime} from './appointmentRenderTime.enum';

export class AppointmentProperties extends ObjectProperties {
  constructor() {
    super();
    this.properties = [
      new QueryableProperty('notes', 'Notes', 'string', false),
      new QueryableProperty('dueDate', 'DueDate', 'date', false),
      new QueryableProperty('title', 'Title', 'string', false),
      new QueryableProperty('dismissed', 'Dismissed', 'boolean', false),
      new QueryableEnum('reminderTime', 'GODH.Application.Core.Entities.Appointments.AppointmentReminderTime', 'ReminderTime', 'enum', false,
        {},
        [
          {
            name: '0 Minutes',
            value: AppointmentReminderTime.On_Time,
            icon: 'fas fa-calendar-check',
            color: 'gray'
          },
          {
            name: '5 Minutes',
            value: AppointmentReminderTime.Minutes_5,
            icon: 'fas fa-calendar-check',
            color: 'gray'
          },
          {
            name: '15 Minutes',
            value: AppointmentReminderTime.Minutes_15,
            icon: 'fas fa-calendar-check',
            color: 'gray'
          },
          {
            name: '30 Minutes',
            value: AppointmentReminderTime.Minutes_30,
            icon: 'fas fa-calendar-check',
            color: 'gray'
          },
          {name: '1 Day', value: AppointmentReminderTime.Days_1, icon: 'fas fa-calendar-check', color: 'gray'},
          {name: '2 Days', value: AppointmentReminderTime.Days_2, icon: 'fas fa-calendar-check', color: 'gray'},
          {name: '3 Days', value: AppointmentReminderTime.Days_3, icon: 'fas fa-calendar-check', color: 'gray'},
          {name: '1 Week', value: AppointmentReminderTime.Weeks_1, icon: 'fas fa-calendar-check', color: 'gray'},
          {name: '2 Week', value: AppointmentReminderTime.Weeks_2, icon: 'fas fa-calendar-check', color: 'gray'}
        ]),
      new QueryableEnum('type', 'GODH.Application.Core.Entities.Appointments.AppointmentType', 'Type', 'enum', false,
        {},
        [
          {name: 'Reminder', value: 1, icon: 'fas fa-bell', color: 'gray'},
          {name: 'Call', value: 2, icon: 'fas fa-phone', color: 'gray'},
          {name: 'Meeting', value: 3, icon: 'fas fa-users', color: 'gray'},
          {name: 'Email', value: 4, icon: 'fas fa-envelope', color: 'gray'},
          {name: 'Task', value: 5, icon: 'fas fa-tasks', color: 'gray'},
          {name: 'Appointment', value: 6, icon: 'fas fa-calendar', color: 'gray'}
        ])
    ];
    this.sortingPropertyName = 'title';
    this.sortingDescending = true;
  }
}

